module.exports = __webpack_public_path__ + "img/ch1.352274c7.png";